/** @jsx jsx */
import { jsx } from '@emotion/react';

import { finalizerCss } from './finalizer-page.css';
import { SURVEYS__SHAPE_ITEM } from '../../../redux/constants';

export function FinalizerPageTermination({ survey }) {
  return (
    <div css={finalizerCss}>
      <div className="finalizer__lead">
        <p>{survey.thankYouCopy}</p>
      </div>
    </div>
  );
}

FinalizerPageTermination.propTypes = {
  survey: SURVEYS__SHAPE_ITEM.isRequired,
};
